import { Component, TemplateRef, ViewChild } from "@angular/core";
import { NgGenerateTableColumns } from "ng-generate-table";
import { Book, BookStatus } from "./book.model";
import { NgBsModalService } from "ng-bs-modal-service";
import { LibraryService } from "./library.service";
import { HttpErrorResponse } from "@angular/common/http";
import { NgBsToastService } from "ng-bs-toast-service";

@Component({
    selector: "app-library",
    standalone: false,
    templateUrl: "./library.component.html",
})
export class LibraryComponent {
    loading = { main: true, modal: false };
    books: Book[] = [];
    currentBook: Book;
    columns: NgGenerateTableColumns[] = [];

    constructor(
        private modalService: NgBsModalService,
        private libraryService: LibraryService,
        private toastService: NgBsToastService,
    ) {}

    ngOnInit(): void {
        // this.books = [
        //     {
        //         id: "a1b2c3d4-0001-4abc-8def-000000000001",
        //         originalFilename: "clean_code.pdf",
        //         title: "Clean Code: A Handbook of Agile Software Craftsmanship",
        //         authors: ["Robert C. Martin"],
        //         edition: "1st",
        //         publisher: "Prentice Hall",
        //         language: "en",
        //         sourceSha256: "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855",
        //         storedPdfUri: "s3://books/clean_code.pdf",
        //         status: BookStatus.READY,
        //         totalPages: 431,
        //         processedPages: 431,
        //         totalChunks: 312,
        //         errorMessage: null,
        //         attempts: 0,
        //         createdAt: new Date("2024-01-10T10:00:00Z"),
        //         updatedAt: new Date("2024-01-10T10:45:00Z"),
        //     },
        //     {
        //         id: "a1b2c3d4-0002-4abc-8def-000000000002",
        //         originalFilename: "design_patterns.pdf",
        //         title: "Design Patterns: Elements of Reusable Object-Oriented Software",
        //         authors: ["Erich Gamma", "Richard Helm", "Ralph Johnson", "John Vlissides"],
        //         edition: "1st",
        //         publisher: "Addison-Wesley",
        //         language: "en",
        //         sourceSha256: "abc123def456abc123def456abc123def456abc123def456abc123def456abc1",
        //         storedPdfUri: "s3://books/design_patterns.pdf",
        //         status: BookStatus.PROCESSING,
        //         totalPages: 395,
        //         processedPages: 210,
        //         totalChunks: 0,
        //         errorMessage: null,
        //         attempts: 0,
        //         createdAt: new Date("2024-02-05T08:30:00Z"),
        //         updatedAt: new Date("2024-02-05T09:10:00Z"),
        //     },
        //     {
        //         id: "a1b2c3d4-0003-4abc-8def-000000000003",
        //         originalFilename: "the_pragmatic_programmer.pdf",
        //         title: "The Pragmatic Programmer",
        //         authors: ["David Thomas", "Andrew Hunt"],
        //         edition: "20th Anniversary",
        //         publisher: "Addison-Wesley",
        //         language: "en",
        //         sourceSha256: null,
        //         storedPdfUri: null,
        //         status: BookStatus.UPLOADED,
        //         totalPages: null,
        //         processedPages: 0,
        //         totalChunks: 0,
        //         errorMessage: null,
        //         attempts: 0,
        //         createdAt: new Date("2024-03-01T14:00:00Z"),
        //         updatedAt: new Date("2024-03-01T14:00:00Z"),
        //     },
        //     {
        //         id: "a1b2c3d4-0004-4abc-8def-000000000004",
        //         originalFilename: "refactoring.pdf",
        //         title: "Refactoring: Improving the Design of Existing Code",
        //         authors: ["Martin Fowler"],
        //         edition: "2nd",
        //         publisher: "Addison-Wesley",
        //         language: "en",
        //         sourceSha256: "deadbeefdeadbeefdeadbeefdeadbeefdeadbeefdeadbeefdeadbeefdeadbeef",
        //         storedPdfUri: "s3://books/refactoring.pdf",
        //         status: BookStatus.FAILED,
        //         totalPages: 448,
        //         processedPages: 120,
        //         totalChunks: 0,
        //         errorMessage: "Timeout while processing pages 121–200",
        //         attempts: 3,
        //         createdAt: new Date("2024-03-15T11:00:00Z"),
        //         updatedAt: new Date("2024-03-15T12:30:00Z"),
        //     },
        //     {
        //         id: "a1b2c3d4-0005-4abc-8def-000000000005",
        //         originalFilename: "estruturas_de_dados.pdf",
        //         title: "Estruturas de Dados e Algoritmos em Java",
        //         authors: ["Michael T. Goodrich", "Roberto Tamassia"],
        //         edition: "5ª",
        //         publisher: "Bookman",
        //         language: "pt",
        //         sourceSha256: "cafebabecafebabecafebabecafebabecafebabecafebabecafebabecafebabe",
        //         storedPdfUri: "s3://books/estruturas_de_dados.pdf",
        //         status: BookStatus.SPLITTING,
        //         totalPages: null,
        //         processedPages: 0,
        //         totalChunks: 0,
        //         errorMessage: null,
        //         attempts: 0,
        //         createdAt: new Date("2024-04-20T09:00:00Z"),
        //         updatedAt: new Date("2024-04-20T09:05:00Z"),
        //     },
        // ];
        this.getBooks();
        this.getColumns();
    }

    getBooks() {
        this.loading.main = true;
        this.libraryService
            .getAll()
            .subscribe({
                next: (res) => {
                    this.books = res.items;
                },
                error: (err: HttpErrorResponse) => this.toastService.send(`Erro ${err.status}`, err.error.message || err.message, "danger"),
            })
            .add(() => (this.loading.main = false));
    }

    @ViewChild("deleteFooter", { static: true }) deleteFooter: TemplateRef<any>;

    getColumns() {
        this.columns = [
            { label: "Nome do Arquivo", template: (rowData: Book) => rowData.original_filename || rowData.title || "Sem título" },
            { label: "Tamanho", template: (rowData: Book) => rowData.size_mb ? rowData.size_mb + ' MB' : '---' },
            { label: "Páginas", template: (rowData: Book) => rowData.total_pages != null ? String(rowData.total_pages) : '---' },
            {
                label: "Status",
                template: (rowData: Book) => {
                    const badge = this.getStatusBadge(rowData.status);
                    if (rowData.status === BookStatus.FAILED && rowData.errorMessage) {
                        return `${badge} <i class="bi bi-exclamation-circle text-danger ms-1" title="${rowData.errorMessage}"></i>`;
                    }
                    return badge;
                },
            },
            {
                tdClass: "td-w-auto",
                template: () =>
                    `<button type="button" class="btn btn-sm btn-link link-danger p-0">
                                <i class="bi bi-trash me-1"></i>Apagar
                             </button>`,
                click: (rowData: Book) => this.openModal(this.deleteFooter, rowData),
            },
        ];
    }

    openModal(footer: TemplateRef<any>, book: Book) {
        this.currentBook = book;
        this.modalService.open(
            {
                header: "Apagar Livro",
                body: `Você tem certeza que deseja apagar o livro <strong>${book.original_filename || book.title || 'este livro'}</strong>?`,
                footer,
            },
            { customClass: { modalHeader: "bg-danger text-white" } },
        );
    }

    closeModal() {
        this.modalService.close();
    }

    deleteBook() {
        this.loading.modal = true;
        this.libraryService
            .delete(this.currentBook.id)
            .subscribe({
                next: () => {
                    this.toastService.send("Sucesso", `Livro ${this.currentBook.original_filename || this.currentBook.title} apagado com sucesso`, "success");
                    this.closeModal();
                    this.getBooks();
                },
                error: (err) => this.toastService.send(`Erro ${err.status}`, err.error.message, "danger"),
            })
            .add(() => (this.loading.modal = false));
    }

    getStatusBadge(status: BookStatus): string {
        const badges: Record<BookStatus, string> = {
            [BookStatus.UPLOADED]: '<span class="badge bg-secondary">Enviado</span>',
            [BookStatus.SPLITTING]: '<span class="badge bg-info text-dark">Dividindo páginas</span>',
            [BookStatus.PROCESSING]: '<span class="badge bg-warning text-dark">Processando</span>',
            [BookStatus.READY]: '<span class="badge bg-success">Processado</span>',
            [BookStatus.FAILED]: '<span class="badge bg-danger">Falhou</span>',
        };

        return badges[status];
    }
}
